import * as _ from "lodash"

export function calculateChangeRatePercent(end: number, start: number): number {
  return start === 0 ? 0 : _.round((100 * (end - start)) / start, 1)
}
